var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.66,
    height: 15.516,
    viewBox: "0 0 15.66 15.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-history",
    "data-name": "Icon akar-history",
    d: "M2.985,12.159A6.941,6.941,0,0,0,6.03,15.253a6.772,6.772,0,0,0,4.256.647,6.841,6.841,0,0,0,3.8-2.054,7.1,7.1,0,0,0,1.045-8.252,6.925,6.925,0,0,0-3.165-2.968,6.767,6.767,0,0,0-4.278-.473A6.43,6.43,0,0,0,4.1,4.3a5.978,5.978,0,0,0-.949,1.385M5.5,5.889l-2.807.56L2,3.556M9,6.667V9.779l2.334,1.556",
    transform: "translate(-1.096 -1.242)",
    fill: "none",
    stroke: "#3971b0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/historyIcon.ed7663be8f49f639eea9b873bbc48fbd.svg";
export { ForwardRef as ReactComponent };